import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { ClientCreateResponse, ClientCreateResquestBody } from "./types";

export class ClientCreateAPI extends BaseAPI<
    ClientCreateResquestBody,
    ClientCreateResponse
> {
    protected route = ApiRoutes.client.create;
    protected method = RequestMethod.POST;
}
